import React from 'react';
import { Box, useTheme } from '@mui/material';

interface GradientBackgroundProps {
  children: React.ReactNode;
}

export const GradientBackground: React.FC<GradientBackgroundProps> = ({
  children,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        overflow: 'hidden',
        position: 'relative',
        backgroundColor: theme.palette.pricingCardGradient.backgroundColor,
        borderRadius: '8px',
      }}
    >
      {/* Background gradient circles */}
      <Box
        sx={{
          position: 'absolute',
          top: '-300px',
          left: '-200px',
          width: '600px',
          height: '600px',
          borderRadius: '50%',
          backgroundColor: theme.palette.pricingCardGradient.gradientBlue,
          filter: 'blur(100px)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '200px',
          right: '-300px',
          width: '700px',
          height: '700px',
          borderRadius: '50%',
          backgroundColor: theme.palette.pricingCardGradient.gradientPurple,
          filter: 'blur(100px)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: '-200px',
          left: '30%',
          width: '500px',
          height: '500px',
          borderRadius: '50%',
          backgroundColor: theme.palette.pricingCardGradient.gradientGreenTeal,
          filter: 'blur(100px)',
        }}
      />

      {/* Wave SVG at the top */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
        }}
      >
        <svg
          viewBox="0 0 1440 200"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            width: '100%',
            height: 'auto',
            opacity: theme.palette.pricingCardGradient.waveOpacity,
          }}
        >
          <path
            fill={theme.palette.pricingCardGradient.waveColor}
            fillOpacity={theme.palette.pricingCardGradient.waveOpacity}
            d="M0,64L48,80C96,96,192,128,288,138.7C384,149,480,139,576,122.7C672,107,768,85,864,90.7C960,96,1056,128,1152,133.3C1248,139,1344,117,1392,106.7L1440,96L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
          />
        </svg>
      </Box>

      {/* Content */}
      <Box sx={{ position: 'relative' }}>{children}</Box>
    </Box>
  );
};
